import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CorporateService } from 'src/app/services/corporate.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Location, TitleCasePipe } from '@angular/common';
import { EnableDisableJDNComponent } from './enable-disable-jdn/enable-disable-jdn.component';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-jdn',
  templateUrl: './jdn.component.html',
  styleUrls: ['./jdn.component.css'],
  providers: [TitleCasePipe]
})
export class JdnComponent implements OnInit {
  corporateDetails: any;
  jdnObject: any;
  currentJDNDetails: any;
  jdnType: string;
  jdnPercentageArray: any = [];
  public jdnForm: UntypedFormGroup;
  isPercentSelected = false;
  api_success: string;
  api_error: any;
  viewJDNDetails = false;
  title: string;
  mode: string;
  jdnStatus: boolean;
  disableBranchJDNBtn = false;
  disableJDNBtn = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private corporateService: CorporateService,
    private formbuilder: UntypedFormBuilder,
    private location: Location,
    private titlecasePipe: TitleCasePipe,
    private dialog: MatDialog,
    private customValidator: CustomValidatorService) { }

  ngOnInit() {
    this.title = 'Set JDN';
    this.createJDNForm();
    this.activatedRoute.queryParams.subscribe(params => {
      this.corporateDetails = params;
      console.log(JSON.stringify(this.corporateDetails));
      this.getJDNFeature(this.corporateDetails.corporateId);
      this.getJDNDetails(this.corporateDetails.corporateId);

    });
  }
  getJDNFeature(corpId) {

    this.corporateService.getJdnFeatures(corpId)
      .subscribe(res => {
        this.jdnObject = res;
        // tslint:disable-next-line:triple-equals
        if (this.jdnObject.JDNType == 'Percent') {
          this.jdnPercentageArray = this.jdnObject.JDNPercent;
          console.log(JSON.stringify('jdnpercentage.......' + JSON.stringify(this.jdnPercentageArray)));
          this.jdnType = 'percent';
        } else {
          this.jdnType = 'Label';
        }

      });



  }
  getJDNDetails(corporateId) {
    this.corporateService.getJDNDetails(corporateId)
      .subscribe(res => {
        this.currentJDNDetails = res;
       
         // this.currentJDNDetails = null;
        // tslint:disable-next-line:triple-equals
        if (this.currentJDNDetails === null || this.currentJDNDetails === undefined) {
          this.viewJDNDetails = false;
        } else {
          if (this.currentJDNDetails.status === 'ENABLED') {
            this.jdnStatus = true;
          } else if (this.currentJDNDetails.status === 'DISABLED') {
                this.jdnStatus = false;
          }
          this.updateJDN();
          this.viewJDNDetails = true;
        }
      });
  }
  editJDN(type) {
    this.mode = type;
    console.log('mode.........' + this.mode);
    this.viewJDNDetails = false;
    this.updateJDN();
  }
  createJDNForm() {
    this.mode = 'add';
    this.jdnForm = this.formbuilder.group({
      label: [],
      discPercentage: ['0'],
      discMax: ['0', [this.customValidator.isPositiveNumber]],
      displayNote: []

    });
  }
  onJDNSubmit() {
   const form_data = this.jdnForm.value;

   console.log(this.jdnType);
      // tslint:disable-next-line:triple-equals
   if (this.jdnType == 'Label') {
    delete form_data.discMax;
    delete form_data.discPercentage;
   }
    // tslint:disable-next-line:triple-equals
    if ( this.mode == 'add') {
      this.disableJDNBtn = true;
      this.corporateService.setJDN(this.corporateDetails.corporateId, form_data)
      .subscribe(res => {
        this.api_success = 'JDN Value set and Enabled Successfully';
        setTimeout(() => {
          this.api_success = '';
          this.disableJDNBtn = false;
          this.getJDNDetails(this.corporateDetails.corporateId);
        }, 2000);
      }, (error) => {
        this.disableJDNBtn = false;
        this.api_error = error.error;
      });
    // tslint:disable-next-line:triple-equals
    } else if (this.mode == 'edit') {
      this.disableJDNBtn = true;
      this.corporateService.updateJDN(this.corporateDetails.corporateId, form_data)
      .subscribe(res => {
        this.api_success = 'JDN Upated Successfully';
        setTimeout(() => {
          this.api_success = '';
          this.disableJDNBtn = false;
          this.getJDNDetails(this.corporateDetails.corporateId);
        }, 2000);
      }, (error) => {
        this.disableJDNBtn = false;
        this.api_error = error.error;
      });

    }

  }

    setJDNForNewBranches() {
      this.disableBranchJDNBtn = true;
      this.corporateService.setJDNForBranches(this.corporateDetails.corporateId)
      .subscribe(res => {
        this.api_success = 'JDN for New Branches Updated Successfully';
        setTimeout(() => {
          this.disableBranchJDNBtn = false;
          this.api_success = '';
          this.getJDNDetails(this.corporateDetails.corporateId);
        }, 2000);
      }, (error) => {
        this.disableBranchJDNBtn = false;
        this.api_error = error.error;
      });
    }


  handleChange() {
    const selectedVal = this.jdnForm.get('discPercentage').value;
    for (const value of this.jdnPercentageArray) {
      // tslint:disable-next-line:triple-equals
      if (selectedVal == value.percentage) {
        this.jdnForm.get('discMax').setValue(value.maxDiscount);
        this.isPercentSelected = true;
      }

    }
  }
  updateJDN() {
    this.jdnForm.patchValue({
      label: this.currentJDNDetails.label,
      discPercentage: this.currentJDNDetails.discPercentage || 0,
      discMax: this.currentJDNDetails.discMax || 0,
      displayNote: this.currentJDNDetails.displayNote,

    });
    if (this.currentJDNDetails.discMax != null) {
      this.isPercentSelected = true;
    }
    this.title = 'Update JDN';
  }
  goBacktoList() {
    this.location.back();
  }

  onChange() {

    const dialogreference = this.dialog.open(EnableDisableJDNComponent, {
      width: '800px',
      data: {'jdnstatus': this.currentJDNDetails.status, 'corporate': this.corporateDetails, 'formValue': this.jdnForm.value}
    });
    dialogreference.afterClosed().subscribe(result => {
      this.getJDNDetails(this.corporateDetails.corporateId);
    });
  }
  capitilizeFirstLetter(textValue) {
    return this.titlecasePipe.transform(textValue);
  }

}
